<template>
  <div v-if="isPC && $store.state.auth.isSignin">
    <UserUpdate />
    <header>
      <div class="container">
        <router-link to="/" class="icn logo main" v-if="isBrosaib" />
        <div class="fl-right tnb">
          <router-link to="/" class="tnb-menu" v-if="!isBrosaib">홈</router-link>
          <router-link to="/saib" class="tnb-menu">사입</router-link>
          <router-link to="/wholesale" class="tnb-menu">도매</router-link>
          <router-link to="/exchange" class="tnb-menu">교환 / 반납</router-link>
          <router-link to="/logs" class="tnb-menu">로그</router-link>
          <router-link to="/history" class="tnb-menu">거래</router-link>
          <router-link to="/question" class="tnb-menu">1:1 문의</router-link>
          <router-link to="/broadcast" class="tnb-menu">삼촌 게시판</router-link>
          <a @click="signout" class="tnb-menu">로그아웃</a>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="main-info-wrapper">
        <p>
          <span class="info">
            <strong>{{ $store.state.auth.username }}</strong>
            ({{ $store.state.auth.identity }})
            <a
              class="icn edit"
              @click="$store.state.auth.editing = true "
            />
          </span>
          <span class="split first">|</span>
          <span class="info">
            잔액:
            <strong>{{ $store.state.auth.balance.current.toLocaleString() }}원</strong>
          </span>
          <span class="second split">|</span>
          <span class="info">
            {{ $store.state.auth.balance.paymentType === 0 ? '납부 금액' : '건당 금액' }}:
            <strong>{{ $store.state.auth.balance.price.toLocaleString() }}원</strong>
          </span>
          <span class="split second" v-if="$store.state.auth.balance.paymentType === 0">|</span>
          <span class="info" v-if="$store.state.auth.balance.paymentType === 0">
            결제 예정일:
            <strong>
              {{ $moment($store.state.auth.balance.paymentDate).format('LL') }}
              ({{ $moment($store.state.auth.balance.paymentDate).fromNow() }})
            </strong>
          </span>
          <span style="float: right;">
            <a-button
              :loading="$store.state.auth.isLoading"
              size="small"
              type="link"
              shape="circle"
              icon="reload"
              @click="refreshMe"
            />
          </span>
        </p>
      </div>
      <div class="main-card-wrapper" style="margin-bottom: 40px;">
        <slot />
      </div>
    </div>
  </div>
  <div v-else-if="!isPC && $store.state.auth.isSignin">
    <UserUpdate />
    <router-link style="z-index: 2;" to="/" v-if="isBrosaib" class="icn logo main type2" />

    <nav role="navigation">
      <div id="menuToggle">
        <input type="checkbox" />
        <div class="nav-bg"></div>
        <span></span>
        <span></span>
        <span></span>

        <ul id="menu">
          <li class="gnb_header">
            <p class="info">
              {{ $store.state.auth.username }}
              <a
                class="icn edit"
                @click="$store.state.auth.editing = true "
              ></a>
            </p>
            <p class="alt">({{ $store.state.auth.identity }})</p>
          </li>
          <li class="gnb_menu">
            <router-link to="/" class="gnb_m btn_go">홈</router-link>
            <router-link to="/saib" class="gnb_m btn_go">사입</router-link>
            <router-link to="/wholesale" class="gnb_m btn_go">도매</router-link>
            <router-link to="/exchange" class="gnb_m btn_go">교환 / 반납</router-link>
            <router-link to="/logs" class="gnb_m btn_go">로그</router-link>
            <router-link to="/history" class="gnb_m btn_go">거래</router-link>
            <router-link to="/question" class="gnb_m btn_go">1:1 문의</router-link>
            <router-link to="/broadcast" class="gnb_m btn_go">삼촌 게시판</router-link>
            <a @click="signout" class="gnb_m btn_go">로그아웃</a>
          </li>
        </ul>
      </div>
    </nav>
    <header>
      <div class="container" />
    </header>
    <div class="main-info-wrapper" style="margin-top: 0px">
      <p>
        <span class="info">잔액:</span>
        <span class="tt">
          <strong>{{ ' ' + $store.state.auth.balance.current.toLocaleString() }}원</strong>
        </span>
        <span class="info">{{ $store.state.auth.balance.paymentType === 0 ? '납부 금액' : '건당 금액' }}:</span>
        <span class="tt">
          <strong>{{ ' ' + $store.state.auth.balance.price.toLocaleString() }}원</strong>
        </span>
        <span class="info" v-if="$store.state.auth.balance.paymentType === 0">결제 예정일:</span>
        <span class="tt" v-if="$store.state.auth.balance.paymentType === 0">
          <strong>{{ ' ' + $moment($store.state.auth.balance.paymentDate).fromNow() }}</strong>
        </span>
      </p>
    </div>
    <div class="container">
      <div class="main-card-wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import UserUpdate from "../Dashboard/UserUpdate";

export default {
  name: "TheHeader",
  methods: mapActions(["refreshMe", "signout"]),
  components: { UserUpdate },
  mounted() {
    this.refreshMe();
  }
};
</script>